  import React, { useState, useEffect } from 'react';
import { Avatar, Card, Checkbox, Tag } from 'antd';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL,DateFormat } from '../Components/Constant';
import { PhoneOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

const LookupDisplayCard = ({ displayFields, fieldValue, objectName,placement }) => {

    const [fieldData, setFieldData] = useState([]);
    const [currency, setCurrency] = useState('');
    const defaultCurrency = useSelector(state=>state.data.orgItem);
   
    const fetchOrgSetupDetails = async () => {
      
          setCurrency(defaultCurrency?.currency);
           
    };
    
      useEffect(() => {
        fetchOrgSetupDetails();
    
      }, []);
  
    // Fetch fields data when component mounts
    useEffect(() => {
        if (objectName) {
            fetchFields(objectName);
        }
    }, [objectName]);

    const fetchFields = async (objectName) => {
        try {
            const objectService = new ApiService(`${BASE_URL}/mt_fields/object/${objectName}`, {}, 'GET');
            const response = await objectService.makeCall();
            setFieldData(response || []);
        } catch (error) {
        }
    };

    const renderField = (field, value) => {
        const type = field?.type || 'default';
        switch (type) {
            case 'boolean':
                return <Checkbox checked={value} disabled />;
            case 'currency':
                return `${currency || '$'}${value !== undefined && value !== null ? parseFloat(value).toFixed(2) : ''}`;
            case 'string':
                return value || '';
            case 'percentage':
                return `${value !== undefined && value !== null ? parseFloat(value) : ''}%`;
            case 'integer':
                return value !== undefined && value !== null ? value : '';
            case 'decimal':
                return value !== undefined && value !== null ? value : '';
            case 'email':
                return value ? <a href={`mailto:${value}`}>{value}</a> : '';
            case 'url':
                return value ? (
                    <a
                        href={value.startsWith('http') ? value : `http://${value}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {value}
                    </a>
                ) : '';
            case 'date':
                return value ? dayjs(value).format(DateFormat) : ''  ;
            case 'datetime':
                return value ? dayjs(value).utc().format('DD/MM/YYYY hh:mm A') : '';
            case 'address':
                return value
                    ? [value.street, value.city, value.state, value.postal_code, value.country]
                        .filter(Boolean)
                        .join(', ')
                    : '';
            case 'formula':
                if (value && typeof value === 'object' && !Array.isArray(value)) {
                    const addressKeys = ['street', 'city', 'state', 'country', 'postal_code', 'pincode'];
                    const addressParts = addressKeys.map(k => value[k]).filter(Boolean);
                    if (addressParts.length > 0) {
                        return addressParts.join(', ');
                    } else {
                        return JSON.stringify(value);
                    }
                }
                if (Array.isArray(value)) {
                    return (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                            {value.map((v, idx) => (
                                <Tag key={idx}>{typeof v === 'object' ? JSON.stringify(v) : String(v)}</Tag>
                            ))}
                        </div>
                    );
                }
                return value ?? '';
            case 'phone':
                return value ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <PhoneOutlined style={{ marginRight: 8 }} />
                        {value || ''}
                    </div>
                ) : '';
            case 'multiselect':
                return Array.isArray(value) ? (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        {value.map((v, i) => (
                            <Tag key={i}>{v}</Tag>
                        ))}
                    </div>
                ) : (
                    value || ''
                );
            case 'richtext':
                return value ? (
                    <div
                        style={{
                            padding: '12px',
                            fontSize: '14px',
                            color: '#555',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            wordBreak: 'break-word',
                            whiteSpace: 'normal',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            maxWidth: '100%',
                        }}
                        dangerouslySetInnerHTML={{ __html: value }}
                    />
                ) : '';
            default:
                // Also handle is_formula fields that may not have type 'formula'
                if (field?.is_formula && value && typeof value === 'object' && !Array.isArray(value)) {
                    const addressKeys = ['street', 'city', 'state', 'country', 'postal_code', 'pincode'];
                    const addressParts = addressKeys.map(k => value[k]).filter(Boolean);
                    if (addressParts.length > 0) {
                        return addressParts.join(', ');
                    } else {
                        return JSON.stringify(value);
                    }
                }
                return value || '';
        }
    };

    return (
        <Card
        style={{
            position: 'absolute',
            top: 0,
            left: '100%',
            marginLeft: 8,
            zIndex: 10,
            width: 'auto',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
            whiteSpace: 'nowrap',
            padding:0,
            borderRadius: '8px',
        }}
    >
        <div
  style={{
    position: "absolute",
    top: "20px",
    ...(placement === "right"
      ? {
          left: "-8px",
          borderRight: "8px solid #fff",
          borderTop: "8px solid transparent",
          borderBottom: "8px solid transparent",
        }
      : {
          right: "-8px",
          borderLeft: "8px solid #fff",
          borderTop: "8px solid transparent",
          borderBottom: "8px solid transparent",
        }),
    transform: "translateY(0)",
    zIndex: 1,
  }}
></div>

    
        {/* Header */}
        <div
            style={{
                marginTop:'2px',
                display: 'flex',
                alignItems: 'flex-start', // Align items to the top
                marginBottom: '8px', // Reduced margin
            }}
        >
           {fieldValue?.image ? (
                     <img
                    //    src={`data:image/png;base64,${fieldValue?.image}`}
                        src={`${BASE_URL}/ImageUpload/${fieldValue?.org_id}/${fieldValue?.image}.png`}

                       alt="profile"
                       style={{
                         width: 24, // Avatar small size
                         height: 24,
                         borderRadius: "50%", // circular
                         objectFit: "cover",
                         marginRight: 6,
                       }}
                     />
                   ) : (
                     <Avatar size="small" style={{ backgroundColor: "#87d068", marginRight: 6 }}>
                       {fieldValue?.Name?.charAt(0).toUpperCase()}
                     </Avatar>
                   )}
            <div
                style={{
                    fontSize: '16px', // Slightly smaller font size for heading
                    fontWeight: 'bold',
                    color: '#333',
                }}
            >
                {fieldValue?.Name || ''}
            </div>
        </div>
    
        {/* Body */}
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr', // Two equal columns
                gap: '8px 16px', // Reduced gap between columns and rows
            }}
        >
            {Array.isArray(displayFields) &&
                displayFields.map((displayFieldName) => {
                    const field = fieldData.find((f) => f.name === displayFieldName);
                    return (
                        <div
                            key={displayFieldName}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                marginBottom: 4, // Reduced margin
                            }}
                        >
                            <span
                                style={{
                                    fontWeight: '300',
                                    marginBottom: '2px', // Reduced space between label and value
                                }}
                            >
                                {field?.label || displayFieldName}
                            </span>
                            <span style={{ fontWeight: '700', color: '#555' }}>
                                {renderField(field, fieldValue[displayFieldName]) || '-'}
                            </span>
                        </div>
                    );
                })}
        </div>
    </Card>
    
    
    );
};

export default LookupDisplayCard;
